module.exports = __webpack_public_path__ + "static/media/01.a2c4eb62.jpg";